<template src="./Index.html">
</template>

<script>
    import AddView from "./actions/Add";
    import EditView from "./actions/Edit";
    import DetailsView from "./details/Details";
    
    export default {
        components: {
            AddView,
            EditView,
            DetailsView,
        },
        created() {
            this.$store.dispatch("lookups/getJobGroups");
            this.getAll();
        },
        computed: {
            
            jobGroups() {
                return [
                    {value:0, label:"الكل"},
                     ...this.$store.state.lookups.jobGroups
                ]
            },
            jobs() {
                return this.$store.state.jobs.jobs;
            },
            pageCount() {
                return Math.ceil(
                   this.$store.state.jobs.totalItems / this.filters.pageSize
                );
            },
        },
        data() {
            return {
                permissions:this.$helpPermissions.jobPermissions,

                items: [
                    {
                        text: "القوائم المساعدة",
                    },  
                    {
                        text: "الوظائف",
                    },
                ],
                totalItems: 0,
                subtitle: "قائمة الاقسام",
                dialog: false,
                dialogType: null,
                dialogMessage: "",
                itemId: 0,
                view: 0,
                filters: {
                    page: 1,
                    pageSize: 10,
                    jobGroupId: 0,
                    jobName: null,
                },
                headers: [
                    {
                        text: "اسم الوظيفة",
                        value: "jobName",
                        sortable: false,
                        align: "start",
                    },
                    {
                        text: "المجموعة التابع لها ",
                        value: "jobGroupName",
                        sortable: false,
                        align: "start",
                    },
                    // { text: "مسجل بواسطة", value: "createdBy", sortable: false },
                    { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
                    { text: "الحالة", value: "status", sortable: false },
                    {
                        text: "الإجراءات",
                        value: "actions",
                        sortable: false,
                        align: "center",
                    },
                ],
            };
        },
        methods: {
            getAll(page) {
                this.filters.page = page || 1;
                this.$store.dispatch("jobs/getAll", this.filters);
            },
            addItem() {
                this.view = 1;
                this.items.push({ text: "إضافة " });

            },
            editItem(item) {
                this.itemId = item.jobId;
                this.view = 2;
                this.items.push({ text: "تعديل " });

            },
            showDetails(item) {
                this.itemId = item.jobId;
                this.view = 3;
                this.items.push({ text: "عرض التفاصيل" });

            },
            showDialog(item, type) {
                switch (type) {
                    case "delete":
                        this.dialogMessage = "هل انت متأكد من رغبتك حذف الوظيفة";
                        break;
                    case "lock":
                        this.dialogMessage = "هل انت متأكد من رغبتك تجميد الوظيفة";
                        break;
                    case "unlock":
                        this.dialogMessage = "هل انت متأكد من رغبتك تفعيل الوظيفة";
                        break;
                }
                this.dialogType = type;
                this.itemId = item.jobId;
                this.dialog = true;
            },

            confirmDialog() {
                this.$store.dispatch(`jobs/${this.dialogType}`, this.itemId);
                this.cancelDialog();
            },

            cancelDialog() {
                this.dialog = false;
                this.itemId = 0;
                this.dialogMessage = "";
                this.dialogType = null;
            },
            back() {
                this.view = 0;
                this.items = [
                    {
                        text: "القوائم المساعدة",
                    },  
                    {
                        text: " الوظائف",
                    },
                ];
            },
            reload() {
                this.filters.jobGroupId = 0;
                this.filters.jobName = null;
                this.getAll(1);
                this.back();
            },
        },
    };
</script>
